import ArticleSlide from './ArticleSlide';

export default ArticleSlide;
